import React from 'react';

const Error = () => (
  <div>
    <p>Requested data are unavailable.</p>
  </div>
);

export default Error;
